import { axiosDelete } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 풀 삭제
export const deleteStakeDbPool = async (poolId: string) => {
  const payload: EndpointPayload = {
    path: `/assetfi/admin/staking/pools/${poolId}`,
    apiUrl: BALANCE_API_URL,
  };

  return await sendRequest(payload, 'deleteStakeDbPool', axiosDelete);
};
